<script>
  import Container from './Container.svelte';
  import {isSingleView} from './store';
  import { default as Modal } from "svelte-simple-modal";
  import Singleview from './Singleview.svelte';

  function testSingleView() {
    let app = document.getElementById("app");
    if (app.getAttribute('data-singleview-url')) return true;
    return false;
  }
  isSingleView.set(testSingleView());
</script>
<Modal>
{#if !$isSingleView}
<Container />
{:else}
<Singleview />
{/if}
</Modal>
